<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">{{ $yuyanbao.xiaoshoutiaokuan }}</h1>
        </div>
      </div>

      <nav class="breadcrumb-nav mb-6">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>{{ $yuyanbao.xiaoshoutiaokuan }}</li>
          </ul>
        </div>
      </nav>

      <div class="page-content">
        <div class="container" v-html="$shezhi.xiaoshoutiaokuan"></div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "CGV",
  components: {},
  data () {
    return {};
  },
  mounted () { },
};
</script>
